import { Base64 } from 'js-base64';
import { ClassConstructor, plainToClass } from 'class-transformer';

export function encodeBase64(str: string): string {
  return Base64.toBase64(str);
}

export function decodeBase64(str: string): string {
  return Base64.fromBase64(str);
}

export function encodeObjectBase64(object: never): string {
  return Base64.toBase64(JSON.stringify(object));
}

export function encodeObject(object: {}): string {
  return Base64.toBase64(JSON.stringify(object));
}

export function decodeObjectBase64<T>(t: ClassConstructor<T>, str: string): T {
  return plainToClass(t, JSON.parse(Base64.fromBase64(str)));
}
